'use client'
import { Icon } from '@/components'
import { EmptyContent } from '@/components/common/empty-content'
import { Box, Grid, Skeleton, Stack, Typography } from '@mui/material'
import { useTranslations } from 'next-intl'
import { TPolicyContent } from '../types'
import parser from 'html-react-parser'

export const Policy = ({ data, isLoading }: { data: TPolicyContent[] | undefined; isLoading?: boolean }) => {
  const t = useTranslations()

  if (!data || data.length === 0) {
    return <EmptyContent title="Chưa có nội dung" />
  }
  return (
    <Grid container spacing={2}>
      {isLoading && <Loading />}
      {data.length > 0 &&
        data.map((item, index) => (
          <Grid key={index} size={{ xs: 12, sm: 6, md: 12, xl: 6 }}>
            <Stack
              direction={'row'}
              justifyContent={'space-between'}
              spacing={1}
              alignItems={'start'}
              sx={{
                p: '1rem',
                bgcolor: '#F4F5F8',
                borderRadius: '8px',
                cursor: 'pointer',
                height: '100%',
              }}
            >
              <Icon.Document sx={{ fontSize: '3.5rem', aspectRatio: '1/1' }} />
              <Stack justifyContent={'flex-start'} alignItems={'flex-start'} sx={{ height: '100%' }}>
                <Typography
                  variant="h5"
                  sx={{
                    fontSize: { xs: '1rem', md: '1.25rem' },
                    fontWeight: 700,
                    marginBottom: '0.5rem',
                    display: { md: '-webkit-box' },
                    WebkitLineClamp: { md: 2 },
                    WebkitBoxOrient: { md: 'vertical' },
                    overflow: { md: 'hidden' },
                  }}
                >
                  {item?.name}
                </Typography>
                <Box
                  sx={{
                    fontSize: { xs: '0.75rem', md: '1rem' },
                    marginBottom: '1rem',
                    display: { md: '-webkit-box' },
                    WebkitLineClamp: { md: 2 },
                    WebkitBoxOrient: { md: 'vertical' },
                    overflow: { md: 'hidden' },
                  }}
                >
                  {parser(item?.short_description || '')}
                </Box>
                <a
                  href={item?.link_url}
                  download
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{ marginTop: 'auto', textDecoration: 'none', color: 'inherit' }}
                >
                  <Stack
                    direction={'row'}
                    spacing={{ sm: 1, xs: 0.5 }}
                    alignItems={'center'}
                    sx={{ '&:hover': { color: 'primary.main' }, cursor: 'pointer' }}
                    component={'span'}
                  >
                    <Icon.Download
                      sx={{
                        fontSize: { xs: '0.75rem!important', md: '1rem!important' },
                        color: 'primary.main',
                      }}
                    />
                    <Typography
                      sx={{ color: 'inherit', fontSize: { xs: '0.75rem', md: '1rem' }, fontWeight: 700 }}
                    >
                      {t('Tải về tại đây')}
                    </Typography>
                  </Stack>
                </a>
              </Stack>
            </Stack>
          </Grid>
        ))}
    </Grid>
  )
}
const Loading = () => {
  return (
    <>
      {Array.from({ length: 4 }).map((_, index) => (
        <Grid key={index} size={{ xs: 12, sm: 6, md: 12, xl: 6 }}>
          <Box sx={{ width: '100%', flex: 1 }}>
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton />
            <Skeleton width="60%" />
          </Box>
        </Grid>
      ))}
    </>
  )
}
